/**
 * A copy of core's `lib/models.ts` (the web build is standalone); `models.test.ts`
 * checks the two agree.
 */

/** `claude-opus-5-5` → "Opus 5.5", `claude-fable-5-1` → "Fable"; anything else as given. */
export function modelLabel(model: string): string {
  const id = model.trim().replace(/\[[^\]]*\]$/, "");
  const match = /^claude-([a-z]+)-(\d+)(?:-(\d{1,2}))?(?:-\d{8})?$/i.exec(id);
  if (!match) return id;
  const family = match[1]!.charAt(0).toUpperCase() + match[1]!.slice(1).toLowerCase();
  // Fable is one model, and people call it by name alone.
  if (family === "Fable") return family;
  return `${family} ${match[2]}${match[3] ? `.${match[3]}` : ""}`;
}

/** Whether the primary is still at its limit at `now`: a reset time that has not passed. */
export const primaryLimited = (agent: { fallbackModel: string | null; primaryLimitedUntil: string | null }, now = Date.now()): boolean =>
  Boolean(agent.fallbackModel && agent.primaryLimitedUntil && Date.parse(agent.primaryLimitedUntil) > now);
